import React, { useEffect, useState } from 'react';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer
} from 'recharts';

import Card from "../ui/card/Card";
import CardTitle from "../ui/card/CardTitle";
import Stack from "../ui/Stack";
import CardList from "../ui/card/CardUlLIst";
import moment from "moment-timezone";

const DashboardChart = ({ data }) => {
    const [chartData, setChartData] = useState(data?.dailyBreakdown);
    const timezone = 'Asia/Kolkata';

    useEffect(() => {
        setChartData(prevState =>
            prevState.map(item => ({
                ...item,
                date: moment(item.date).tz(timezone).format('MMM DD'),
            }))
        );
    }, []);

    return (
        <div className="row my-5">
            <div className="col-12 mb-5">
                <Card className="border-0 p-3">
                    <Stack>
                        <CardTitle className="mb-5 me-auto" title="Order" subTitle="Last 30 Days" />
                        <CardList
                            className="m-0 text-end"
                            items={[
                                `Orders: ${data?.totalOrders}`,
                                `Pending Payment: ${data?.pendingPaymentsCount}`,
                            ]}
                        />
                    </Stack>

                    <div style={{ height: '200px' }}>
                        <ResponsiveContainer width="100%" height="100%">
                            <LineChart data={chartData} margin={{ top: 10, right: 8, left: -8, bottom: 0 }}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="date" tick={{ fontSize: 14 }} />
                                <YAxis tick={{ fontSize: 14 }}/>
                                <Tooltip />
                                <Line type="monotone" dataKey="totalOrders" name="Total Orders" stroke="#fd7e14" activeDot={{ r: 8 }} />
                            </LineChart>
                        </ResponsiveContainer>
                    </div>
                </Card>
            </div>
            <div className="col-12">
                <Card className="border-0 p-3">
                    <Stack>
                        <CardTitle className="mb-5 me-auto" title="Revenue" subTitle="Last 30 Days" />
                        <CardList
                            className="m-0 text-end"
                            items={[
                                `Revenue: ₹${data?.totalRevenue}`,
                                `Pending Payments Amount: ${data?.pendingPaymentsAmount}`,
                            ]}
                        />
                    </Stack>
                    <div style={{ height: '200px'}}>
                        <ResponsiveContainer width="100%" height="100%">
                            <LineChart data={chartData} margin={{ top: 10, right: 8, left: -8, bottom: 0 }}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="date" tick={{ fontSize: 14 }} />
                                <YAxis tick={{ fontSize: 14 }}/>
                                <Tooltip />
                                <Line type="monotone" dataKey="totalRevenue" name="Total Revenue" stroke="#34a853" activeDot={{ r: 8 }} />
                            </LineChart>
                        </ResponsiveContainer>
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default DashboardChart;
